import { useMemo } from "react";
import { useSelector } from "react-redux";
import jobSelectors from "store/selectors/job";

export interface FooterPropsHook {
  total: number;
}

export default function useFooterProps(): FooterPropsHook {
  const job = useSelector(jobSelectors.getEntity);

  const total = useMemo(
    () => job?.total?.amount_vat_inclusive?.amount || 0,
    [job]
  );

  return {
    total,
  };
}
